import React, { Component } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { FormattedDate, FormattedNumber } from 'react-intl';
import FormattedDateTime from '../format/FormattedDateTime';
import DeletePortfolioAsset from './DeletePortfolioAsset';
import SellPortfolioAsset from './SellPortfolioAsset';
import color from '../../config/color';
import { AssetWithCalculatedStats } from '../../interfaces/interfaces';

interface Props {
  asset?: AssetWithCalculatedStats;
  deletable: boolean;
  show: boolean;
  hide: () => void;
}

export default class PortfolioAssetModal extends Component<Props> {
  /*
    This component is showing info about a equity in a modal.
  */

  hideModal = () => {
    this.props.hide();
  };

  render() {
    const { asset } = this.props;
    if (!asset) return null;
    return (
      <Modal {...this.props} show={this.props.show} onHide={this.hideModal}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">{asset.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table hover responsive size="sm">
            <tbody className="no-border">
              <tr>
                <td>Kostpris</td>
                <td>
                  <FormattedNumber
                    minimumFractionDigits={0}
                    maximumFractionDigits={0}
                    value={asset.totalPrice}
                  />
                </td>
              </tr>
              <tr>
                <td>Dato investert</td>
                <td>
                  {asset.transactionTimestamp > 0 ? (
                    <FormattedDate
                      value={new Date(asset.transactionTimestamp)}
                    />
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
              <tr>
                <td>Antall</td>
                <td>
                  <FormattedNumber
                    minimumFractionDigits={0}
                    maximumFractionDigits={10}
                    value={asset.stockholding}
                  />
                </td>
              </tr>
              <tr>
                <td>Siste kurs (NOK)</td>
                <td>
                  <FormattedNumber
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                    value={asset.price}
                  />
                </td>
              </tr>
              <tr>
                <td>Oppdatert</td>
                <td>
                  <FormattedDateTime
                    timestamp={asset.lastUpdatedTimestamp}
                    type={asset.type}
                    showClockPrefix
                  />
                </td>
              </tr>
              <tr>
                <td>ID</td>
                <td>{asset.externalId}</td>
              </tr>
              {asset.hourlyChange && (
                <tr>
                  <td>Siste time</td>
                  <td className={color.getClassName(asset.hourlyChange)}>
                    {asset.percentChange ? (
                      <FormattedNumber // eslint-disable-next-line
                        style="percent"
                        minimumFractionDigits={2}
                        maximumFractionDigits={2}
                        value={asset.hourlyChange / 100}
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
              )}
              <tr>
                <td>Siste dag</td>
                <td className={color.getClassName(asset.percentChange)}>
                  {asset.percentChange ? (
                    <FormattedNumber // eslint-disable-next-line
                      style="percent"
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                      value={asset.percentChange / 100}
                    />
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
              {asset.weeklyChange && (
                <tr>
                  <td>Siste uke</td>
                  <td className={color.getClassName(asset.weeklyChange)}>
                    {asset.percentChange ? (
                      <FormattedNumber // eslint-disable-next-line
                        style="percent"
                        minimumFractionDigits={2}
                        maximumFractionDigits={2}
                        value={asset.weeklyChange / 100}
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
              )}
              <tr>
                <td>Avkastning</td>
                <td>
                  <FormattedNumber
                    minimumFractionDigits={0}
                    maximumFractionDigits={0}
                    value={asset.return}
                  />
                </td>
              </tr>
              <tr>
                <td>Avkastning %</td>
                <td className={color.getClassName(asset.percentReturn)}>
                  {asset.percentReturn ? (
                    <FormattedNumber // eslint-disable-next-line
                      style="percent"
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                      value={asset.percentReturn}
                    />
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
              <tr>
                <td>Årlig avkastning %</td>
                <td className={color.getClassName(asset.annualPercentReturn)}>
                  {asset.annualPercentReturn ? (
                    <FormattedNumber // eslint-disable-next-line
                      style="percent"
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                      value={asset.annualPercentReturn}
                    />
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
              <tr>
                <td>Total verdi</td>
                <td>
                  <FormattedNumber
                    minimumFractionDigits={0}
                    maximumFractionDigits={0}
                    value={asset.totalValue}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        {this.props.deletable && (
          <Modal.Body>
            <SellPortfolioAsset asset={asset} />
          </Modal.Body>
        )}
        <Modal.Footer>
          {this.props.deletable && <DeletePortfolioAsset asset={asset} />}
          <Button variant="light" onClick={this.hideModal}>
            Lukk
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
